<template>
  <div class="reference-price-manage">
    <GlobalInfoBar
      title="风险串号管理"
      content="可在此处查看和维护平台认定的风险串号，此处维护的风险串号，在报价师报价时会提醒"
    />
    <div class="mb-10">
      <GardenSlwct
        :tab-data="tabData"
        :activeIndex="tabActiveIndex"
        border-radius="40px"
        @tabAction="tabActionChange"
      >
      </GardenSlwct>
    </div>
    <GlobalChunk icon="search" title="筛选查询" v-if="tabActiveIndex === 0">
      <div slot="filter">
        <div class="el-form-group_isRound">
          <el-form
            ref="searchForm"
            :model="searchForm"
            inline
            size="small"
            label-width="95px"
          >
            <el-form-item label="标记时间">
              <el-date-picker
                v-model="entryTime"
                type="daterange"
                start-placeholder="开始日期"
                range-separator="~"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                clearable
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="串号/序列号">
              <el-input
                v-model="searchForm.code"
                placeholder="请输入串号/序列号查询"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="订单号" label-width="80px">
              <el-input
                v-model="searchForm.orderNo"
                placeholder="请输入订单号查询"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="风险描述">
              <el-input
                v-model="searchForm.detailedRisks"
                placeholder="请输入风险描述查询"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="订单来源商家" label-width="120px">
              <el-select
                v-model="searchForm.companyId"
                clearable
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in companySelectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提醒报价师开关" label-width="130px">
              <el-select
                v-model="searchForm.isRemind"
                clearable
                placeholder="请选择"
              >
                <el-option label="开启" :value="true" />
                <el-option label="关闭" :value="false" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                round
                :loading="searchLoading"
                @click="getTableData(1)"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="mb-10" style="display: flex;justify-content: flex-end;">
          <el-button type="warning" size="small" @click="importDiaShow = true"
            >批量导入</el-button
          >
          <el-button
            type="success"
            size="small"
            :loading="exportLoading"
            @click="exportExcel"
            >导出Excel</el-button
          >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="openAddDia"
            >新增风险机串号</el-button
          >
        </div>
      </div>
      <GlobalTable
        ref="GlobalTable"
        v-loading="searchLoading"
        :columns="tableColumns"
        :data="tableDataList"
        :currentPage="page.pageNum"
        :total="page.total"
        :pageSize="page.pageSize"
        @handleCurrentChange="getTableData"
      >
        <el-table-column label="串号1" slot="imeiOne" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.imeiOne || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="串号2" slot="imeiTwo" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.imeiTwo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="序列号" slot="serialNo" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.serialNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="机型" slot="machineName" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.machineName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="风险简述" slot="briefRisks" align="center">
          <template slot-scope="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              :content="row.briefRisks"
              placement="top"
            >
              <div class="nowrap-ellipsis">
                {{ row.briefRisks }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="风险详细描述"
          slot="detailedRisks"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              :content="row.detailedRisks"
              placement="top"
            >
              <div class="nowrap-ellipsis">
                {{ row.detailedRisks }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="关联订单号" slot="orderNo" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.orderNo" class="btn" @click="goDetails(row)">{{
              row.orderNo
            }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="询价门店" slot="companyName" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.companyName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="图片" slot="img" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.imgs && row.imgs.length">
              <img style="max-height: 70px;" :src="row.imgs[0]" alt="" />
              <p @click="voucherView(row)" class="btn">
                共{{ row.imgs.length }}张
              </p>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="提醒报价师开关" slot="isRemind" align="center">
          <template slot-scope="{ row }">
            <el-switch
              inactive-color="#bebebe"
              @change="remindSwitchChange(row)"
              v-model="row.isRemind"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="已触发次数" slot="triggerCount" align="center">
          <template slot-scope="{ row }">
            <span
              class="btn"
              @click="openTriggerDetailsDia(row)"
              >{{ row.triggerCount || 0 }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="标记人" slot="marker" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.creatorUserName }}-{{ row.creatorUserPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          slot="operation"
          align="center"
          min-width="120"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="editRow(row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>
    <triggerRecordTable :companySelectList="companySelectList" v-if="tabActiveIndex === 1" />
    <el-dialog
      :title="addDiaType === 'add' ? '新增风险串号' : '编辑风险串号'"
      v-if="addDiaShow"
      :visible.sync="addDiaShow"
      :close-on-click-modal="false"
      width="660px"
      top="50px"
      @close="addDiaClose"
    >
      <div style="height: 700px;overflow-y: scroll;">
        <el-form
          ref="imeiForm"
          :model="imeiForm"
          :rules="taskRules"
          label-width="120px"
        >
          <el-form-item label="串号1：" prop="imeiOne">
            <el-input
              size="small"
              clearable
              v-model.trim="imeiForm.imeiOne"
              placeholder="请输入风险机串号"
              maxlength="15"
              show-word-limit
              @input="numInputSet('imeiOne')"
            ></el-input>
          </el-form-item>
          <el-form-item label="串号2：">
            <el-input
              size="small"
              clearable
              v-model.trim="imeiForm.imeiTwo"
              placeholder="可输入此风险机另一串号，非必填"
              maxlength="15"
              show-word-limit
              @input="numInputSet('imeiTwo')"
            ></el-input>
          </el-form-item>
          <el-form-item label="序列号：">
            <el-input
              size="small"
              clearable
              v-model.trim="imeiForm.serialNo"
              placeholder="可输入此风险机序列号，非必填"
              maxlength="20"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="机型及规格：">
            <el-input
              size="small"
              clearable
              v-model.trim="imeiForm.machineName"
              placeholder="请输入机型名称和机型规格"
              maxlength="20"
              show-word-limit
            ></el-input>
            <p style="line-height: 14px;color: #999999;">
              非必填，若关联了订单编号，会自动填入订单机型，可自行修改
            </p>
          </el-form-item>
          <el-form-item label="风险简述：" prop="briefRisks">
            <el-input
              size="small"
              clearable
              v-model.trim="imeiForm.briefRisks"
              placeholder="请简单描述此风险"
              maxlength="12"
              show-word-limit
            ></el-input>
            <p style="line-height: 14px;color: #999999;">
              将会展示给报价师，请简单明了的简述风险问题
            </p>
          </el-form-item>
          <el-form-item label="风险详细描述：" prop="detailedRisks">
            <el-input
              size="small"
              type="textarea"
              clearable
              v-model.trim="imeiForm.detailedRisks"
              placeholder="请详情描述存在的风险"
              maxlength="100"
              show-word-limit
              :rows="4"
            ></el-input>
            <p style="line-height: 16px;color: #999999;">
              将会展示给报价师，请详细描述清楚。
            </p>
          </el-form-item>
          <el-form-item label="询价门店" prop="companyId">
            <el-select
              v-model="imeiForm.companyId"
              clearable
              filterable
              placeholder="可输入选择询价门店"
            >
              <el-option
                v-for="item in companySelectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联订单号：">
            <el-input
              size="small"
              clearable
              v-model.trim="imeiForm.orderNo"
              placeholder="可输入关联订单号，非必填"
              maxlength="15"
              show-word-limit
              @input="numInputSet('orderNo')"
            ></el-input>
          </el-form-item>
          <el-form-item label="风险/串号图：">
            <JudgementsList
              :is-reset="isResponsibilityReset"
              :source-data="imgs"
              :fileSize="2"
              @dataChange="(v) => judgementsChange(v)"
              :sourceData="imgs"
            />
            <p class="red_txt">
              请上传风险/串号图（限3张内，大小不超过2M，格式为JPG或PNG）
            </p>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDiaClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="createBtnLoading"
          @click="sureCreateImei"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="安全验证"
      :visible.sync="commandDisableShow"
      :close-on-click-modal="false"
      width="500px"
      @closed="commandClosed"
    >
      <div v-if="tipExplain" style="margin-bottom: 20px;">
        <span style="color: #ff8695;font-size: 14px;">{{ tipExplain }}</span>
      </div>
      <div class="tip-centent">
        <span>{{ commandTipText }}</span>
      </div>
      <div class="command">
        <div style="width: max-content">谷歌验证码：</div>
        <el-input v-model="command" placeholder="请输入谷歌动态口令"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="commandDisableShow = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="commandSure"
          :loading="commandButLoading"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <PhotoPreview
      :photoVisible="photoDialogProp.show"
      :photoArr="photoDialogProp.photoArr"
      title="风险/串号图"
      @close="photoPreviewClose"
    />
    <ImportDia
      v-if="importDiaShow"
      :dialogVisible="importDiaShow"
      @close="importDiaShow = false"
      @importSuccess="importSuccess"
    />
    <TriggerDetailsDia
      v-if="triggerDetailsDiaShow"
      :dialogVisible="triggerDetailsDiaShow"
      :currentRow="currentRow"
      :companySelectList="companySelectList"
      @close="triggerDetailsDiaShow = false"
    />
  </div>
</template>

<script>
import _api from "@/utils/request";
import { MessageBox } from "element-ui";
import GardenSlwct from "@/components/common/gardenSlwct.vue";
import moment from "moment";
import PhotoPreview from "@/components/common/PhotoPreview.vue";
import JudgementsList from "./componets/JudgementsList.vue";
import ImportDia from "./dialog/ImportDia.vue";
import triggerRecordTable from "./triggerRecordTable.vue";
import TriggerDetailsDia from "./dialog/TriggerDetailsDia.vue";
export default {
  name: "aiReadPictures",
  components: {
    GardenSlwct,
    PhotoPreview,
    triggerRecordTable,
    JudgementsList,
    ImportDia,
    TriggerDetailsDia,
  },
  data() {
    return {
      tabData: [
        {
          text: "风险串号",
          value: "01",
          hideNum: true,
        },
        {
          text: "触发记录",
          value: "02",
          hideNum: true,
        },
      ],
      tabActiveIndex: 0,
      searchLoading: false,
      entryTime: [
        moment()
          .day(moment().day() - 6)
          .format("YYYY-MM-DD 00:00:00"),
        moment().format("YYYY-MM-DD 23:59:59"),
      ],
      pickerMinDate: null,
      pickerMaxDate: null,
      day31: 30 * 24 * 3600 * 1000,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (
              time.getTime() > this.pickerMinDate + this.day31 ||
              time.getTime() < this.pickerMinDate - this.day31
            );
          }
          return false;
        },
      },
      searchForm: {
        code: "",
        orderNo: "",
        detailedRisks: "",
        companyId: "",
        isRemind: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableDataList: [],
      tableColumns: [
        {slotName:"imeiOne"},
        { slotName: "imeiTwo" },
        { slotName: "serialNo" },
        { slotName: "machineName" },
        { slotName: "briefRisks" },
        { slotName: "detailedRisks" },
        { slotName: "orderNo" },
        { slotName: "companyName" },
        { slotName: "img" },
        { slotName: "isRemind" },
        { slotName: "triggerCount" },
        { slotName: "marker" },
        { label: "最新标记时间", prop: "updateTime" },
        { slotName: "operation" },
      ],
      photoDialogProp: {
        show: false,
        photoArr: [],
      },
      isResponsibilityReset: false,
      currentRow: {},
      // 新增任务弹框
      addDiaShow: false,
      addDiaType: "add",
      imeiForm: {
        imeiOne: "",
        imeiTwo: "",
        serialNo: "",
        briefRisks: "",
        detailedRisks: "",
        companyId: "",
        orderNo: "",
        machineName: "",
      },
      imgs: [],
      createBtnLoading: false,
      taskRules: {
        // imeiOne: [{ required: true, message: "请输入串号1", trigger: "blur" }],
        briefRisks: [
          { required: true, message: "请输入风险简述", trigger: "blur" },
        ],
        detailedRisks: [
          { required: true, message: "请输入风险详细描述", trigger: "blur" },
        ],
        companyId: [
          { required: true, message: "请选择询价门店", trigger: "change" },
        ],
      },
      companySelectList: [],
      classList: [],
      brandList: [],
      modelList: [],
      capacityList: [],
      // 安全验证弹框
      command: "",
      commandDisableShow: false,
      commandTipText: "",
      commandType: "",
      tipExplain: "",
      commandButLoading: false,
      // 批量导入弹框
      importDiaShow: false,
      exportLoading: false,
      // 触发详情弹框
      triggerDetailsDiaShow: false,
    };
  },
  created() {
    const { code } = this.$route.query;
    if(code){
      this.searchForm.code = code
    }
    this.getTableData(1);
    this.getCompanySelectList();
  },
  methods: {
    tabActionChange(val) {
      this.tabActiveIndex = val;
      if (val === 0) {
        this.getTableData(1);
      }
    },
    getTableData(pageNum) {
      if (pageNum) {
        this.page.pageNum = pageNum;
      }
      let startTime = "";
      let endTime = "";
      if (this.entryTime === null) {
        (startTime = ""), (endTime = "");
      } else {
        (startTime = moment(this.entryTime[0]).format("x")),
          (endTime = moment(this.entryTime[1]).format("x"));
      }
      const baseRequest = {
        ...this.searchForm,
        startTime,
        endTime,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.searchLoading = true;
      _api
        .riskNumberList(baseRequest)
        .then((res) => {
          if (res.code === 1) {
            this.tableDataList = res.data.records;
            this.page.pageNum = res.data.current;
            this.page.total = res.data.total;
          }
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    // 照片预览
    voucherView(row) {
      this.photoDialogProp.show = true;
      this.photoDialogProp.photoArr = row.imgs;
    },
    photoPreviewClose() {
      this.photoDialogProp.show = false;
      this.photoDialogProp.photoArr = [];
    },
    editRow(row) {
      this.addDiaType = "edit";
      this.imeiForm = {
        imeiOne: row.imeiOne,
        imeiTwo: row.imeiTwo,
        serialNo: row.serialNo,
        briefRisks: row.briefRisks,
        detailedRisks: row.detailedRisks,
        companyId: row.companyId,
        orderNo: row.orderNo,
        id: row.id,
        machineName: row.machineName,
      };
      if (row.imgs && row.imgs.length) {
        this.imgs = row.imgs.map((item) => {
          return {
            url: item,
            reason: "",
            judgeType: "",
          };
        });
      }

      this.addDiaShow = true;
    },
    // 请输入大于0的整数
    numInputSet(key) {
      this.imeiForm[key] = this.imeiForm[key].toString().replace(/\D/g, "");
    },
    openAddDia() {
      this.addDiaType = "add";
      this.addDiaShow = true;
    },
    // 门店商家
    getCompanySelectList() {
      _api.getrchantSelectList().then((res) => {
        this.companySelectList = res.data;
      });
    },
    // 风险/串号图
    judgementsChange(v) {
      this.imgs = v;
    },
    addDiaClose() {
      this.imeiForm = {
        imeiOne: "",
        imeiTwo: "",
        serialNo: "",
        briefRisks: "",
        detailedRisks: "",
        companyId: "",
        orderNo: "",
        machineName: "",
      };
      this.imgs = [];
      this.addDiaShow = false;
    },
    sureCreateImei() {
      this.$refs.imeiForm.validate((valid) => {
        if (valid) {
          this.tipExplain =
            "此风险串号添加后，若再次出现在平台中，将为报价师展示风险详情";
          this.commandTipText =
            this.addDiaType === "add"
              ? "是否确认添加风险串号？"
              : "是否确认修改？";
          this.commandType = "create";
          this.commandDisableShow = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    remindSwitchChange(row) {
      this.currentRow = row;
      this.tipExplain = "开关影响的是报价师侧的风险提醒，请谨慎操作！";
      this.commandTipText = row.isRemind ? "是否确认开启？" : "是否确认关闭？";
      this.commandType = "isRemind";
      this.commandDisableShow = true;
    },
    commandClosed() {
      this.command = "";
      this.tipExplain = "";
      if (this.commandType === "isRemind") {
        this.getTableData();
      }
    },
    commandSure() {
      if (!this.command.trim()) {
        return this.$message.error("请输入动态口令");
      }
      this.commandButLoading = true;
      if (this.commandType === "create") {
        let parame = {
          ...this.imeiForm,
          imgs: this.imgs.map((item) => item.url),
          command: this.command,
        };
        _api
          .riskNumberSave(parame)
          .then((res) => {
            if (res.code === 1) {
              this.$message.success(res.msg || "操作成功");
              this.getTableData();
              this.commandDisableShow = false;
              this.addDiaShow = false;
              this.addDiaClose();
            }
          })
          .finally(() => {
            this.commandButLoading = false;
          });
      } else if (this.commandType === "isRemind") {
        let parame = {
          id: this.currentRow.id,
          isRemind: this.currentRow.isRemind,
          command: this.command,
        };
        _api
          .updateRemind(parame)
          .then((res) => {
            if (res.code === 1) {
              this.$message.success(res.msg || "操作成功");
              this.getTableData();
              this.commandDisableShow = false;
            }
          })
          .finally(() => {
            this.commandButLoading = false;
          });
      }
    },
    importSuccess() {
      this.getTableData(1);
    },
    exportExcel() {
      let startTime = "";
      let endTime = "";
      if (this.entryTime === null) {
        (startTime = ""), (endTime = "");
      } else {
        (startTime = moment(this.entryTime[0]).format("x")),
          (endTime = moment(this.entryTime[1]).format("x"));
      }
      const baseRequest = {
        ...this.searchForm,
        startTime,
        endTime,
      };
      this.exportLoading = true;
      _api
        .riskNumberExport(baseRequest)
        .then((res) => {
          console.log(res);
          const content = res;
          const blob = new Blob([content]);
          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            //
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                MessageBox.alert(data.msg, "错误提示", {
                  type: "error",
                });
              }
            } catch (err) {
              const fileName = "风险串号管理列表.xlsx";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8");
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    // 订单详情
    goDetails(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.orderNo },
      });
      window.open(routeData.href, "_blank");
    },
    openTriggerDetailsDia(row) {
      this.currentRow = JSON.parse(JSON.stringify(row));
      this.triggerDetailsDiaShow = true;
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.reference-price-manage {
  .flex {
    display: flex;
    align-items: center;
  }
  .red_txt {
    color: #ff687b;
    font-size: 14px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .mr-20 {
    margin-right: 20px;
  }
  .btn {
    text-decoration: underline;
    cursor: pointer;
    color: #0981ff;
  }
  .tip-centent {
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px;
  }
  .command {
    display: flex;
    align-items: center;
    /deep/.el-input {
      width: 300px;
    }
  }
  .nowrap-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
</style>
